import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MockupSection } from './components/MockupSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  return <div className="w-full min-h-screen bg-[#0a0a0a] text-white" data-id="element-0">
      {/* 1. HOOK EMOCIONAL */}
      <HeroSection data-id="element-1" />

      {/* 2. EL PROBLEMA REAL */}
      <ProblemSection data-id="element-2" />

      {/* 3. LA SOLUCIÓN (PRODUCTO) */}
      <MockupSection data-id="element-3" />

      {/* 5. PRUEBA SOCIAL */}
      <TestimonialsSection data-id="element-4" />

      {/* 6. GARANTÍA */}
      <GuaranteeSection data-id="element-5" />

      {/* 7. OFERTA */}
      <OfferSection data-id="element-6" />

      {/* 8. PREGUNTAS FRECUENTES */}
      <FAQSection data-id="element-7" />

      {/* 9. CIERRE */}
      <FinalCTASection data-id="element-8" />
    </div>;
}